(function () {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const UTM_STORAGE_KEY = 'utmParams';
  const PREFERRED_COUNTRY_KEY = 'preferredCountry';

  // Paths excluded from country auto-redirect (visitors stay on standoil.global).
  // Match is by pathname prefix, so it covers trailing slashes and query strings.
  const REDIRECT_EXCLUDED_PATHS = ['/pages/promotion_2607sale'];

  const COUNTRIES = {
    KR: {
      code: 'KR',
      baseUrl: 'https://standoil.kr/',
      redirectedKey: 'krRedirected'
    },
    TW: {
      code: 'TW',
      baseUrl: 'https://standoil.tw/',
      redirectedKey: 'twRedirected'
    },
    JP: {
      code: 'JP',
      baseUrl: 'https://standoil.jp/',
      redirectedKey: 'jpRedirected'
    }
  };

  // (1) Capture and store UTM parameters
  function storeUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmData = {};
    let hasUTM = false;

    for (const key of UTM_KEYS) {
      const value = urlParams.get(key);
      if (value) {
        utmData[key] = value;
        hasUTM = true;
      }
    }

    if (hasUTM) {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmData));
    } else {
      localStorage.removeItem(UTM_STORAGE_KEY);
    }
  }

  // (2) Build redirect URL with UTM params
  function buildRedirectUrl(baseUrl, countryCode) {
    const redirectUrl = new URL(baseUrl);
    redirectUrl.searchParams.set('country', countryCode);

    try {
      const storedUTM = JSON.parse(localStorage.getItem(UTM_STORAGE_KEY) || '{}');
      if (Object.keys(storedUTM).length > 0) {
        for (const [key, value] of Object.entries(storedUTM)) {
          redirectUrl.searchParams.set(key, value);
        }
      } else {
        redirectUrl.searchParams.set('utm_source', 'standoilglobal');
        redirectUrl.searchParams.set('utm_medium', 'referral');
        redirectUrl.searchParams.set('utm_campaign', 'country_redirect');
      }
    } catch {
      console.warn('Invalid UTM data in localStorage');
    }

    return redirectUrl.toString();
  }

  // (3) Handle redirect for a given country
  function handleRedirect(countryConfig) {
    localStorage.setItem(PREFERRED_COUNTRY_KEY, countryConfig.code);
    window.location.href = buildRedirectUrl(countryConfig.baseUrl, countryConfig.code);
  }

  // (4) Attach event handlers for country selection
  function initCountrySelectorHandlers() {
    // Handle links with data-country-selector-list
    const countryLinks = document.querySelectorAll('[data-country-selector-list]');
    countryLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const selectedCode = link.getAttribute('data-country-selector-list');
        const countryConfig = COUNTRIES[selectedCode];
        if (countryConfig) {
          e.preventDefault();
          if (window.location.hostname === new URL(countryConfig.baseUrl).hostname) return;
          handleRedirect(countryConfig);
        }
      });
    });

    // Watch for Shopify-style country selector buttons
    const observer = new MutationObserver(() => {
      const shopNowBtn = document.querySelector('button.adt-changeBtn');
      const countryBtn = document.querySelector('button.adt-disclosure-btn');

      if (shopNowBtn && countryBtn && !shopNowBtn.hasAttribute('data-handler-attached')) {
        shopNowBtn.setAttribute('data-handler-attached', 'true');

        shopNowBtn.addEventListener('click', () => {
          const code = countryBtn.getAttribute('data-code');
          const countryConfig = COUNTRIES[code];
          if (countryConfig) {
            handleRedirect(countryConfig);
          }
        });

        // Stop observing once attached
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // (5) Auto-redirect if preferred country matches
  function handleAutoRedirect() {
    const currentPath = window.location.pathname;
    const isExcluded = REDIRECT_EXCLUDED_PATHS.some((path) => currentPath.startsWith(path));
    if (isExcluded) return;

    const userCountry = localStorage.getItem(PREFERRED_COUNTRY_KEY);

    if (!userCountry || !COUNTRIES[userCountry]) return;

    const { baseUrl, code, redirectedKey } = COUNTRIES[userCountry];
    const alreadyRedirected = sessionStorage.getItem(redirectedKey);

    if (!alreadyRedirected && window.location.hostname !== new URL(baseUrl).hostname) {
      sessionStorage.setItem(redirectedKey, 'true');
      window.location.href = buildRedirectUrl(baseUrl, code);
    }
  }

  // Init
  storeUTMParams();
  document.addEventListener('DOMContentLoaded', initCountrySelectorHandlers);
  handleAutoRedirect();
})();
